import React, { useEffect, useState, useRef, useContext, useMemo } from 'react'
import { useRouter } from 'next/router'
import { api } from '../../../utils'
import { PERSONALIZZAZIONICARRELLO, LEADTIME } from '../../../utils/endpoint'
import TecnicaCard from '../../molecules/TecnicaCard/TecnicaCard'
import TecnicaConsigliata from '../../molecules/TecnicaConsigliata/TecnicaConsigliata'
import FormSelect from '../../atoms/FormSelect/FormSelect'
import useTrans from '../../../hooks/useTrans'
import MyImage from '../../atoms/MyImage/MyImage'
import FormRadio from '../../atoms/FormRadio/FormRadio'
import Button from '../../atoms/Button/Button'
import { Altezza, Clipboard, Customize, Info, Larghezza, Zoom } from '../../atoms/NewIcons/index'
import FormField from '../../atoms/FormField/FormField'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import FormInput from '../../atoms/FormInput/FormInput'
import { handleScrollRef, priceNotation } from '../../../utils/safe'
import NewModal from '../../molecules/NewModal/NewModal'
import * as Sentry from '@sentry/browser'
import { _uploadLoghiDimensioni } from '../UploadLoghi/UploadLoghi'
import ConfigurazioneProdottoConferma from '../ConfigurazioneProdottoConferma/ConfigurazioneProdottoConferma'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import Link from 'next/link'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import * as yup from 'yup'
import { useFormik } from 'formik'
import {
  trackingAddCart,
  trackingCreaOfferta,
  trackingGAEventProdotto,
  trackingSalvaPerDopo,
} from '../../../utils/gtm'
import NoFornitoreModal from '../NoFornitoreModal/NoFornitoreModal'
import Alert from '../../atoms/Alert/Alert'
import { getMaxQuantitaOrdinabileLeadTime } from '../../../utils/leadtime'
import {
  EDITOR_FROM_CART_MAIN,
  EDITOR_FROM_PDP,
  getEditorUrl,
  hasEditorPerm,
} from '@utils/editor-bozze'
import { useSelector } from 'react-redux'
import { getPrezzoPersonalizzazione, getTecnicaConsigliata } from '../../../utils/personalizzazioni'

const getPrezzoUnitario = (prezziTecnica, quantita) => {
  const quantitaTotale =
    quantita && Array.isArray(quantita)
      ? quantita.reduce((acc, curr) => acc + (curr.quantita || 0), 0)
      : 0
  const prezzoItem =
    prezziTecnica?.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
  if (!prezzoItem?.prezzi_personalizzazione || quantitaTotale === 0) return null
  // Il badge economico usa il primo prezzo anche sotto lo scaglione minimo.
  return (
    getPrezzoPersonalizzazione(prezzoItem, quantitaTotale) ??
    prezzoItem.prezzi_personalizzazione[0]?.prezzo ??
    null
  )
}

const getCostoImpiantoUnitario = (prezziTecnica, quantita) => {
  const quantitaTotale =
    quantita && Array.isArray(quantita)
      ? quantita.reduce((acc, curr) => acc + (curr.quantita || 0), 0)
      : 0
  const prezzo = prezziTecnica?.costo_impianto || 0
  if (!prezzo || quantitaTotale === 0) return 0
  return prezzo / quantitaTotale
}

const trackFinalStep = (first_articolo, prodotto, selectedTecnica) => {
  const titolo = first_articolo?.titolo || ''
  const codice = prodotto?.codice || ''
  const tecnica = selectedTecnica?.nome || ''

  trackingGAEventProdotto(
    'customization_funnel',
    'c_step4_caricamento_loghi',
    undefined,
    titolo,
    codice,
    tecnica
  )

  trackingGAEventProdotto(
    'customization_funnel',
    'c_step5_nome_logo_OLD',
    undefined,
    titolo,
    codice,
    tecnica
  )

  trackingGAEventProdotto(
    'customization_complete',
    'c_step6_personalizzazione_confermata',
    undefined,
    titolo,
    codice,
    tecnica
  )
}

const checkIsColorNotAllowed = (color, allColors) =>
  allColors.findIndex(({ id }) => id === color) === -1

const ConfigurazioneProdotto = ({
  prodotto,
  personalizzazioni,
  prezziPersonalizzazioni,
  leadTimePersonalizzazioni,
  quantita,
  isLoading,
  setLoading,
  AddToCart,
  AddToCartMain,
  OrdinaSubito,
  SaveLater,
  resetCarrello,
  ModificaArticoli,
  setShowPersonalizzaForm,
  ordine,
  needRecomputePreventivo,
  setNeedRecomputePreventivo,
  doRecomputePreventivo,
  isAggiornaPreventivoEnabled,
  setAggiornaPreventivoEnabled,
  isAlreadyAggiornaPreventivoEnabled, // dopo la prima volta che viene aggiornato il preventivo diventa true
  setAlreadyAggiornaPreventivoEnabled,
  setDoRecomputePreventivo,
  variant,
  editorSource,
  personalizzazioneId,
  initialValues,
  isFormValid,
  setFormValid,
  leadTimeSelected,
  setLeadTimeSelected,
}) => {
  const isEdit = variant === 'personalizzazione' && personalizzazioneId
  const router = useRouter()
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)
  const { service_gift } = useSelector((state) => state.servicegift)
  const { width } = useWindowDimensions()
  const editorSourceParam = useMemo(() => {
    if (variant === 'prodotto') return EDITOR_FROM_PDP

    return editorSource || EDITOR_FROM_CART_MAIN
  }, [variant, editorSource])

  const selectedArticlesColors = useMemo(() => {
    const selectedArticlesIds = quantita.reduce(
      (acc, { id, quantita }) => (quantita > 0 ? [...acc, id] : acc),
      []
    )
    return (prodotto?.articoli ?? []).reduce((acc, { id, attributi_lista }) => {
      if (selectedArticlesIds.includes(id)) {
        const articleColorId = attributi_lista.find(
          ({ attributo_chiave }) => attributo_chiave === 'colore'
        ).id
        if (articleColorId && !acc.includes(articleColorId)) acc.push(articleColorId)
      }
      return acc
    }, [])
  }, [quantita, prodotto?.articoli])

  const tecniche = useMemo(() => {
    const tecnicheProdotto = personalizzazioni?.tecniche ?? []
    return tecnicheProdotto.filter(({ colori }) =>
      colori?.length > 0
        ? !selectedArticlesColors.some((color) => checkIsColorNotAllowed(color, colori))
        : true
    )
  }, [personalizzazioni, prezziPersonalizzazioni, quantita, selectedArticlesColors])

  const tecnicaEconomica = useMemo(() => {
    if (!personalizzazioni?.tecniche || !prezziPersonalizzazioni?.tecniche) return null
    let minPrezzo = null
    let min = null
    personalizzazioni.tecniche.forEach((tecnica) => {
      const prezziTecnica = prezziPersonalizzazioni.tecniche.find((t) => t.id === tecnica.id)
      const prezzoUnitario =
        getPrezzoUnitario(prezziTecnica, quantita) +
        getCostoImpiantoUnitario(prezziTecnica, quantita)
      if (
        typeof prezzoUnitario === 'number' &&
        (minPrezzo === null || prezzoUnitario < minPrezzo)
      ) {
        minPrezzo = prezzoUnitario
        min = tecnica
      }
    })
    return min
  }, [personalizzazioni, prezziPersonalizzazioni, quantita])

  const first_articolo = prodotto?.articoli.length > 0 ? prodotto?.articoli[0] : null
  const [selectedTecnica, setSelectedTecnica] = useState(
    initialValues ? initialValues?.tecnica : null
  )
  const [posizioni, setPosizioni] = useState(initialValues ? initialValues?.posizioni : [])
  const [configurazioneConsigliata, setConfigurazioneConsigliata] = useState(null)
  const [nomeLavorazioneAssegnato, setNomeLavorazioneAssegnato] = useState(
    initialValues && initialValues?.nomeLavorazioneManuale ? initialValues?.nomeLavorazione : ''
  )
  const [showAnnullaConfigurazioneModal, setShowAnnullaConfigurazioneModal] = useState(false)
  const [showPrenotazioneModal, setShowPrenotazioneModal] = useState(false)
  const [confezionamentoRichiesto, setConfezionamentoRichiesto] = useState(
    initialValues?.confezionamento ? true : false
  )
  const quantitaTotale = useMemo(() => {
    return quantita.reduce((acc, curr) => acc + (curr.quantita || 0), 0)
  }, [quantita])

  useEffect(() => {
    if (leadTimePersonalizzazioni && !selectedTecnica) {
      // se tutte le tecniche sono disabilitate
      if (
        leadTimePersonalizzazioni?.tecniche?.every(
          (t) =>
            !t?.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.leadtime
              ?.fornitore
        )
      ) {
        // imposto come lead time quello con la quantità max ordinabile più alta
        const fallback = getMaxQuantitaOrdinabileLeadTime(leadTimePersonalizzazioni)
        setLeadTimeSelected(fallback ? { ...fallback, qtyCalcolata: quantitaTotale } : fallback)
      }
    }
  }, [leadTimePersonalizzazioni, quantitaTotale, selectedTecnica])

  const getLeadTimePersonalizzazione = (tecnica, posizione, numeroColore) => {
    return leadTimePersonalizzazioni?.tecniche
      ?.find((t) => t.id === tecnica?.id)
      ?.posizioni?.find((p) => p.id === posizione?.id)
      ?.numero_colori?.find((nc, i) => (numeroColore ? nc.id === numeroColore.id : i === 0))
      ?.personalizzazioni_objects?.[0] // se non passi numeroColore utilizziamo il primo
  }

  useEffect(() => {
    if (!selectedTecnica) return

    const params = {
      lang: router.locale,
      qty: quantitaTotale,
      confezionamento: confezionamentoRichiesto,
    }

    posizioni?.forEach((pos, idx) => {
      params[`pers${idx + 1}`] = pos.colori?.personalizzazioni_objects?.[0]?.id
    })
    // Applica solo la risposta della richiesta corrente: una risposta precedente arrivata
    // in ritardo non deve sovrascrivere il lead time né avviare l'aggiornamento del preventivo.
    let richiestaAttuale = true
    api
      .get(`${LEADTIME}${prodotto.codice}/`, { params })
      .then((data) => {
        if (!richiestaAttuale) return
        setLeadTimeSelected(data.data ? { ...data.data, qtyCalcolata: quantitaTotale } : data.data)
        setConfigurazioneConsigliata((corrente) =>
          corrente?.posizioni === posizioni ? { ...corrente, leadTimePronto: true } : corrente
        )
      })
      .catch((errore) => {
        console.error(errore)
        if (richiestaAttuale) {
          setConfigurazioneConsigliata(null)
          if (configurazioneConsigliata) setLoading(false)
        }
      })
    // Invalida la richiesta quando cambia la configurazione o il componente viene smontato.
    return () => {
      richiestaAttuale = false
    }
  }, [leadTimePersonalizzazioni, posizioni, confezionamentoRichiesto, quantitaTotale])

  const validationSchema = yup.object({
    nomeLavorazione: yup
      .string()
      .matches(/^[^0-9]*$/, 'Solo lettere')
      .min(3, t('Minimo 3 caratteri'))
      .max(14, t('Massimo 14 caratteri')),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nomeLavorazione:
        initialValues && initialValues?.nomeLavorazioneManuale
          ? initialValues?.nomeLavorazioneNoIncrementale
          : '',
    },
    validationSchema,
  })

  useEffect(() => {
    // In PDP gli initialValues possono arrivare dopo il mount, quando il restore
    // legge il preventivo salvato dall'editor. Questo effect riallinea il form.
    setSelectedTecnica(initialValues?.tecnica || null)
    setPosizioni(initialValues?.posizioni || [])
    setConfezionamentoRichiesto(!!initialValues?.confezionamento)
    setNomeLavorazioneAssegnato(
      initialValues?.nomeLavorazioneManuale ? initialValues?.nomeLavorazione : ''
    )
    setPersonalizzazioneCarrello(personalizzazioneId || null)
  }, [initialValues, personalizzazioneId])

  useEffect(() => {
    initialValues?.tecnica &&
      trackingGAEventProdotto(
        'customization_funnel',
        'c_step0_tecnica_stampa',
        undefined,
        first_articolo?.titolo || '',
        prodotto?.codice || '',
        initialValues?.tecnica?.nome || ''
      )
  }, [])

  const handleAggiungiPosizione = () => {
    if (!selectedTecnica) return
    if (posizioni.length >= 2) return

    const nuovaPosizione = selectedTecnica.posizioni?.find(
      (p) => !posizioni.some((pos) => pos.id === p.id)
    )

    if (nuovaPosizione) {
      setPosizioni([
        ...posizioni,
        {
          ...nuovaPosizione,
          colori: nuovaPosizione.numero_colori?.[0],
          pantoni_codici: [],
          selectedAltezza:
            nuovaPosizione.numero_colori?.[0]?.personalizzazioni_objects[0].dimensione_altezza,
          selectedLarghezza:
            nuovaPosizione.numero_colori?.[0]?.personalizzazioni_objects[0].dimensione_larghezza,
        },
      ])
    }
  }

  const handleRimuoviPosizione = (index) => {
    if (posizioni.length <= 1) return
    setPosizioni((prev) => prev.filter((_, i) => i !== index))
  }

  const handleChangePosizione = (index, key, value) => {
    const updated = [...posizioni]
    if (key === 'posizione') {
      const nuovaPosizione = selectedTecnica.posizioni?.find((x) => x.id === value)
      if (nuovaPosizione) {
        updated[index] = {
          ...nuovaPosizione,
          colori: nuovaPosizione.numero_colori?.[0],
          pantoni_codici: [],
          selectedAltezza:
            nuovaPosizione.numero_colori?.[0]?.personalizzazioni_objects[0].dimensione_altezza,
          selectedLarghezza:
            nuovaPosizione.numero_colori?.[0]?.personalizzazioni_objects[0].dimensione_larghezza,
        }
      }
    } else {
      updated[index][key] = value
    }
    setPosizioni(updated)
  }

  const confezionamentoLabel = useMemo(() => {
    return posizioni[0]?.colori?.personalizzazioni_objects?.length > 0
      ? posizioni[0]?.colori?.personalizzazioni_objects[0].confezionamento
      : null
  }, [posizioni])

  const confezionamentoRichiestoOption = useMemo(() => {
    return posizioni[0]?.colori?.personalizzazioni_objects?.length > 0
      ? posizioni[0]?.colori?.personalizzazioni_objects[0].confezionamento_richiesto
      : null
  }, [posizioni])

  const prezzoConfezionamento = useMemo(() => {
    return posizioni[0]?.colori?.personalizzazioni_objects?.length > 0
      ? posizioni[0]?.colori?.personalizzazioni_objects[0].prezzo_confezionamento
      : null
  }, [posizioni])

  const articoliPreventivo = useMemo(() => {
    return quantita
      .map((q) => prodotto.articoli?.find((a) => a.codice === q.codice))
      ?.filter((x) => !!x)
  }, [prodotto, quantita])

  const getAreaStampa = (personalizzazione) => {
    return personalizzazione?.aree_stampa?.find(
      (a) =>
        a.colore?.id ===
        articoliPreventivo?.[0]?.attributi_lista?.find((attr) => attr.attributo_chiave === 'colore')
          .id
    )
  }

  // TODO: Da capire se necessario
  // useEffect(() => {
  //   confezionamentoRichiestoOption === 'D'
  //     ? ((confezionamento_richiesto = true), setConfezionamentoRichiesto(true))
  //     : ''

  //   confezionamentoRichiestoOption === 'N'
  //     ? ((confezionamento_richiesto = false), setConfezionamentoRichiesto(false))
  //     : ''

  //   confezionamentoRichiestoOption === 'S'
  //     ? ((confezionamento_richiesto = false), setConfezionamentoRichiesto(false))
  //     : ''
  // }, [])

  const [isValid, setIsValid] = useState(isFormValid || false)
  const [posizioniDuplicate, setPosizioniDuplicate] = useState(false)
  const [modalLogoOpen, setModalLogoOpen] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [personalizzazioneCarrello, setPersonalizzazioneCarrello] = useState(personalizzazioneId)
  const [isLeadTimeValid, setLeadTimeValid] = useState(true)
  const [showNoFornitoreModal, setShowNoFornitoreModal] = useState(false)

  const editorHref = useMemo(() => {
    if (!personalizzazioneCarrello || !ordine?.id) return undefined

    return getEditorUrl({
      personalizzazioneId: personalizzazioneCarrello,
      editorOwnerId: ordine.id,
      source: editorSourceParam,
    })
  }, [personalizzazioneCarrello, ordine?.id, editorSourceParam])

  useEffect(() => {
    if (!quantitaTotale) {
      setLeadTimeValid(false)
      setShowNoFornitoreModal(false)
      return
    }

    if (!leadTimeSelected || leadTimeSelected?.qtyCalcolata !== quantitaTotale) {
      return
    }

    const hasFornitore = !!leadTimeSelected.fornitore
    setLeadTimeValid(hasFornitore)
    setShowNoFornitoreModal(!hasFornitore)
  }, [quantitaTotale, leadTimeSelected])

  useEffect(() => {
    if (!!setFormValid) {
      // se è passata come prop tengo allineato isValid con isFormValid
      setFormValid(isValid)
    }
  }, [isValid])

  useEffect(() => {
    const isFormikPartValid = formik.isValid // Check Yup validation

    if (!selectedTecnica) {
      setIsValid(false)
      return
    }

    if (!isFormikPartValid) {
      setIsValid(false)
      return
    }

    if (!isLeadTimeValid) {
      setIsValid(false)
      return
    }

    if (posizioni.length > 0 && posizioni.every((pos) => pos.colori)) {
      // Verifica duplicati
      const ids = posizioni.map((pos) => pos.id)
      const hasDuplicates = new Set(ids).size !== ids.length
      setPosizioniDuplicate(hasDuplicates)
      setIsValid(!hasDuplicates)
      return
    }

    setPosizioniDuplicate(false)
    setIsValid(false)
  }, [selectedTecnica, posizioni, formik.isValid, isLeadTimeValid])

  const [posizioniFetch, setPosizioniFetch] = useState([])

  const aggiornaPreventivo = async (isPrenotazioneConfermata = false) => {
    trackingGAEventProdotto(
      'customization_funnel',
      'c_step1_posizione_stampa',
      undefined,
      first_articolo?.titolo || '',
      prodotto?.codice || '',
      selectedTecnica?.nome || ''
    )
    trackingGAEventProdotto(
      'customization_funnel',
      'c_step2_config_stampa_OLD',
      undefined,
      first_articolo?.titolo || '',
      prodotto?.codice || '',
      selectedTecnica?.nome || ''
    )
    trackingGAEventProdotto(
      'customization_funnel',
      confezionamentoRichiesto ? 'c_step3_confezionamento_si' : 'c_step3_confezionamento_no',
      undefined,
      first_articolo?.titolo || '',
      prodotto?.codice || '',
      selectedTecnica?.nome || ''
    )
    const params = {
      nome_lavorazione: formik.values.nomeLavorazione,
      confezionamento_richiesto: confezionamentoRichiesto,
      posizioni: posizioni.map((pos) => ({
        changedAltezza:
          pos.selectedAltezza !== pos.colori.personalizzazioni_objects[0].dimensione_altezza,
        changedLarghezza:
          pos.selectedLarghezza !== pos.colori.personalizzazioni_objects[0].dimensione_larghezza,
        ...(personalizzazioneCarrello && {
          altezza: pos.selectedAltezza,
          larghezza: pos.selectedLarghezza,
          pantoni_codici: pos.pantoni_codici,
          descrizione_posizione: pos.descrizione_posizione,
          logo_file: pos.logo_file_id,
          tracciatura_logo: pos.tracciatura_logo,
        }),
        personalizzazione_id: pos.colori.personalizzazioni_objects[0].id,
        personalizzazione: pos.colori.personalizzazioni_objects[0],
        // selectedColore: pos.numero_colori.find(n => n.codice === pos.colori.codice),
      })),
    }

    setLoading(true)
    try {
      const response = await (personalizzazioneCarrello
        ? api.put(`${PERSONALIZZAZIONICARRELLO}${personalizzazioneCarrello}/`, params)
        : api.post(`${PERSONALIZZAZIONICARRELLO}`, params))
      setPersonalizzazioneCarrello(response.data.id)

      const status = await AddToCart(quantita, response.data.id, isPrenotazioneConfermata, false)
      if (status) {
        // ritorna false se bisogna prima confermare la prenotazione
        setPosizioniFetch(response.data.posizioni)
        if (response.data.nome_lavorazione_manuale) {
          // se l'utente ha inserito il nome visualizzo sotto all'input il nome con eventuale incrementale
          setNomeLavorazioneAssegnato(response.data.nome_lavorazione)
        } else {
          setNomeLavorazioneAssegnato(null)
        }
        setAggiornaPreventivoEnabled(true)
        !isAlreadyAggiornaPreventivoEnabled &&
          !!setAlreadyAggiornaPreventivoEnabled &&
          setAlreadyAggiornaPreventivoEnabled(true) // diventa true dopo il primo aggiornamento del preventivo
        setShowPrenotazioneModal(false)
      } else {
        status !== undefined && setShowPrenotazioneModal(!showPrenotazioneModal)
      }
    } catch (err) {
      Sentry.captureException(err)
      displayNotification('error.pers.edit', t('Qualcosa è andato storto'), 'error')
    } finally {
      setLoading(false)
    }
  }

  const MakePayloadWithFiles = async (filesSelected, callback) => {
    if (filesSelected) {
      setLoading(true)
      // Prepara tutte le promesse di upload
      const uploadPromises = posizioniFetch.map(async (posizione, index) => {
        const posizioneData = posizioni[index]
        return _uploadLoghiDimensioni({
          id: posizione.id,
          file_to_upload: filesSelected[index],
          descrizione_posizione: posizioneData?.descrizione_posizione,
          altezza: posizioneData?.selectedAltezza,
          larghezza: posizioneData?.selectedLarghezza,
          pantoni_codici: posizioneData?.pantoni_codici,
          setLoading: setIsUploading,
        })
      })
      try {
        await Promise.all(uploadPromises)
        callback()
        setShowPersonalizzaForm(false)
        setLoading(false)
      } catch (err) {
        setLoading(false)
        displayNotification('upload.loghi.error', err.message, 'error')
      }
    }
  }

  useEffect(() => {
    if (modalLogoOpen) document.body.classList.add('w-noscroll')
    else document.body.classList.remove('w-noscroll')

    return () => document.body.classList.remove('w-noscroll')
  }, [modalLogoOpen])

  const getPrezzoColore = (tecnica, posizione, colore) => {
    const configurazione = prezziPersonalizzazioni?.tecniche
      ?.find((t) => t.id === tecnica.id)
      ?.posizioni?.find((x) => x.id === posizione.id)
      ?.numero_colori?.find((x) => x.id === colore.id)?.personalizzazioni_objects?.[0]
    return getPrezzoPersonalizzazione(configurazione, quantitaTotale)
  }

  const resetConfirm = () => {
    if (isAggiornaPreventivoEnabled) {
      resetCarrello()
      setAggiornaPreventivoEnabled(false)
    }
  }

  // per triggerare l'azione da componente esterno
  useEffect(() => {
    if (needRecomputePreventivo) {
      resetConfirm()
      !!setNeedRecomputePreventivo && setNeedRecomputePreventivo(false)
    }
  }, [needRecomputePreventivo])

  // per triggerare l'azione da componente esterno
  useEffect(() => {
    if (doRecomputePreventivo) {
      aggiornaPreventivo()
      setDoRecomputePreventivo(false)
    }
  }, [doRecomputePreventivo])

  const [zoomModalIndex, setZoomModalIndex] = useState(null)

  const filterPosizioniByLeadTime = (posizioni, idx = 0) => {
    // se prima posizione
    if (idx === 0) {
      return posizioni.filter(
        (pos) => getLeadTimePersonalizzazione(selectedTecnica, pos)?.fornitori?.length > 0
      )
    } else {
      // se la seconda posizione
      // o la posizione può essere fatta dallo stesso fornitore selezionato dalla prima posizione
      // o esiste un altro fornitore che può fare anche la prima posizione
      return posizioni.filter((pos) => {
        const primaPosizione = posizioni?.[0]
        const primaPosizioneLeadTime = getLeadTimePersonalizzazione(
          selectedTecnica,
          primaPosizione,
          primaPosizione?.colori
        )
        const currentLeadTime = getLeadTimePersonalizzazione(selectedTecnica, pos) // relativo al primo colore
        return (
          currentLeadTime?.fornitori?.length > 0 &&
          (currentLeadTime?.fornitori?.includes(leadTimeSelected.fornitore) ||
            currentLeadTime?.fornitori?.some((f) => primaPosizioneLeadTime?.fornitori?.includes(f)))
        )
      })
    }
  }

  const filterColoriByLeadTime = (colori, posizione, idx = 0) => {
    // se prima posizione
    if (idx === 0) {
      return colori.filter(
        (c) => getLeadTimePersonalizzazione(selectedTecnica, posizione, c)?.fornitori?.length > 0
      )
    } else {
      // se la seconda posizione
      // o il colore può essere fatto dallo stesso fornitore selezionato dalla prima posizione
      // o esiste un altro fornitore che può fare anche il colore della prima posizione
      return colori.filter((c) => {
        const primaPosizione = posizioni?.[0]
        const primaPosizioneLeadTime = getLeadTimePersonalizzazione(
          selectedTecnica,
          primaPosizione,
          primaPosizione?.colori
        )
        const currentLeadTime = getLeadTimePersonalizzazione(selectedTecnica, posizione, c)
        return (
          currentLeadTime?.fornitori?.length > 0 &&
          (currentLeadTime?.fornitori?.includes(leadTimeSelected.fornitore) ||
            currentLeadTime?.fornitori?.some((f) => primaPosizioneLeadTime?.fornitori?.includes(f)))
        )
      })
    }
  }

  const tecnicheDisabled = useMemo(() => {
    if (!leadTimePersonalizzazioni) return []

    return tecniche.filter(
      (tecnica) =>
        !leadTimePersonalizzazioni?.tecniche?.find((t) => t.id === tecnica.id)?.posizioni?.[0]
          ?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.leadtime?.fornitore
    )
  }, [tecniche, leadTimePersonalizzazioni])

  const consigliPerPosizione = useMemo(() => {
    const parametri = {
      posizioni,
      confrontoSulTotale: true,
      tecnicaSelezionata: selectedTecnica,
      tecniche: tecniche.filter((t) => !tecnicheDisabled.some((d) => d.id === t.id)),
      prezzi: prezziPersonalizzazioni,
      leadTime: leadTimePersonalizzazioni,
      quantita: quantitaTotale,
    }
    if (parametri.confrontoSulTotale) {
      const consiglio = getTecnicaConsigliata(parametri)
      return posizioni.map(() => consiglio)
    }
    return posizioni.map((_, indicePosizione) =>
      getTecnicaConsigliata({ ...parametri, indicePosizione })
    )
  }, [
    posizioni,
    selectedTecnica,
    tecniche,
    tecnicheDisabled,
    prezziPersonalizzazioni,
    leadTimePersonalizzazioni,
    quantitaTotale,
  ])

  const handleApplicaConsiglio = (consiglio) => {
    if (isLoading || isUploading || configurazioneConsigliata || !formik.isValid) return
    // Mostra subito il loader, anche durante l'attesa del nuovo lead time.
    setLoading(true)
    handleSelezionaTecnica(consiglio.tecnica, consiglio.posizioni)
    setConfigurazioneConsigliata({ ...consiglio, quantitaCalcolata: quantitaTotale })
  }

  useEffect(() => {
    if (!configurazioneConsigliata) return
    if (
      configurazioneConsigliata.posizioni !== posizioni ||
      configurazioneConsigliata.tecnica !== selectedTecnica ||
      configurazioneConsigliata.quantitaCalcolata !== quantitaTotale
    ) {
      setConfigurazioneConsigliata(null)
      setLoading(false)
      return
    }
    if (!configurazioneConsigliata?.leadTimePronto) return
    setConfigurazioneConsigliata(null)
    // Esegue il submit solo dopo il render con tecnica, posizioni e lead time nuovi.
    // Se la combinazione non ha fornitori resta attivo il normale avviso del form.
    if (leadTimeSelected?.fornitore && formik.isValid && quantitaTotale > 0) {
      aggiornaPreventivo()
    } else {
      setLoading(false)
    }
  }, [configurazioneConsigliata, leadTimeSelected, posizioni, selectedTecnica, quantitaTotale])

  const handleSelezionaTecnica = (tecnica, posizioniConsigliate) => {
    // Una scelta esplicita deve azzerare le posizioni anche tornando alla tecnica
    // degli initialValues, che l'effect distingue dal ripristino del preventivo.
    setConfigurazioneConsigliata(null)
    setSelectedTecnica(tecnica)
    if (posizioniConsigliate) {
      // Il consiglio ricalcola subito il carrello: invalida la conferma senza svuotarlo prima.
      setAggiornaPreventivoEnabled(false)
    } else {
      resetConfirm()
    }
    if (tecnica) {
      trackingGAEventProdotto(
        'customization_funnel',
        'c_step0_tecnica_stampa',
        undefined,
        first_articolo?.titolo || '',
        prodotto?.codice || '',
        tecnica.nome || ''
      )
    }
    // Le card ripartono dalla prima posizione; il consiglio applica quelle già calcolate.
    const primaPosizione = tecnica?.posizioni?.[0]
    const colori = primaPosizione?.numero_colori?.[0]
    const configurazione = colori?.personalizzazioni_objects?.[0]
    setPosizioni(
      posizioniConsigliate ??
        (primaPosizione
          ? [
              {
                ...primaPosizione,
                colori,
                pantoni_codici: [],
                selectedAltezza: configurazione?.dimensione_altezza,
                selectedLarghezza: configurazione?.dimensione_larghezza,
              },
            ]
          : [])
    )
    if (width < 767) {
      handleScrollRef(document.getElementById('pos_0'))
    }
  }

  const reset = () => {
    resetConfirm()
    !!setNeedRecomputePreventivo && setNeedRecomputePreventivo(false)
  }

  return (
    <div className="configurazione-prodotto">
      {/* Tecnica di stampa */}
      <div className="configurazione-prodotto__item">
        <h2 className="configurazione-prodotto__title">
          {t('Seleziona la tecnica di stampa che desideri configurare')}
        </h2>
        {quantitaTotale > 0 &&
          leadTimeSelected?.qtyCalcolata === quantitaTotale &&
          tecnicheDisabled?.length > 0 && (
            <Alert
              full
              noClick={true}
              // variant={'info'}
              icon={<></>}
              placeholder={tecnicheDisabled?.map((tecnica) => (
                <span key={tecnica.id}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'Per la tecnica <strong>{0}</strong> il massimo ordinabile da web è: <strong>{1} pz</strong>',
                        [
                          tecnica.nome,
                          getMaxQuantitaOrdinabileLeadTime(leadTimePersonalizzazioni, tecnica.id)
                            ?.max_quantita_ordinabile,
                        ]
                      ),
                    }}
                  />
                  <span className="consegna-prevista__info">
                    <Tooltip
                      label={t(
                        "Per quantità superiori a quella indicata contattare l'ufficio commerciale"
                      )}
                    >
                      <Info />
                    </Tooltip>
                  </span>
                  <br></br>
                </span>
              ))}
              link={null}
              className="configurazione-prodotto__alert-tecnica"
            />
          )}
        {quantitaTotale > 0 &&
          leadTimeSelected?.alert_quantita &&
          quantitaTotale >= leadTimeSelected.alert_quantita && (
            <Alert
              full
              noClick={true}
              variant={'warning'}
              icon={<></>}
              placeholder={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "Per questo quantitativo le date di spedizione verranno verificate dall'ufficio commerciale alla conferma dell'ordine.<br />Puoi anche richiedere un preventivo personalizzato su misura all'ufficio commerciale."
                    ),
                  }}
                />
              }
              link={null}
              className="configurazione-prodotto__alert-tecnica"
            />
          )}
        <div className="configurazione-prodotto__tecniche">
          {tecniche && tecniche.length > 0 ? (
            tecniche.map((tecnica, index) => (
              <TecnicaCard
                key={index}
                tecnica={tecnica}
                selected={selectedTecnica?.id == tecnica?.id}
                setSelectedTecnica={handleSelezionaTecnica}
                prezziTecnica={prezziPersonalizzazioni?.tecniche?.find((t) => t.id === tecnica.id)}
                leadTime={
                  selectedTecnica?.id === tecnica?.id &&
                  leadTimeSelected?.tecnica_id === selectedTecnica?.id
                    ? leadTimeSelected
                    : leadTimePersonalizzazioni?.tecniche?.find((t) => t.id === tecnica.id)
                        ?.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                        ?.leadtime
                }
                disabled={!!tecnicheDisabled?.find((t) => t.id === tecnica.id) || isLoading}
                quantita={quantita}
                consigliata={tecnica.consigliata}
                economica={tecnicaEconomica ? tecnicaEconomica.id === tecnica.id : false}
              />
            ))
          ) : (
            <p className="configurazione-prodotto__tecniche-message">
              {t('Non è disponibile nessuna tecnica di stampa per gli articoli selezionati')}
            </p>
          )}
        </div>
      </div>

      {/* Posizioni - lista */}
      {!selectedTecnica && <div id="pos_0" />}
      {selectedTecnica &&
        posizioni
          .filter(
            (pos) => getLeadTimePersonalizzazione(selectedTecnica, pos)?.fornitori?.length > 0
          )
          .map((pos, idx) => (
            <div className="configurazione-prodotto__item" id={'pos_' + idx} key={idx}>
              <h2 className="configurazione-prodotto__title">
                {t('Seleziona la posizione di stampa che desideri configurare')}
              </h2>
              <div
                className={`configurazione-prodotto__posizioni configurazione-prodotto__posizioni--configuratore ${
                  posizioni.length === 2 ? 'configurazione-prodotto__posizioni--rimovibile' : ''
                }`}
                key={idx}
              >
                <div className="configurazione-prodotto__posizioni__head">
                  <div className="configurazione-prodotto__posizioni__select">
                    <span className="configurazione-prodotto__posizioni__select__label">
                      {t('Scegli la posizione di stampa')}:
                    </span>
                    <FormField id={`selezione_posizione_${idx}`}>
                      <FormSelect
                        placeholder={t('Seleziona Posizione')}
                        options={
                          filterPosizioniByLeadTime(selectedTecnica?.posizioni, idx)
                            ?.filter(
                              (x) =>
                                posizioni?.[idx]?.id === x.id ||
                                !posizioni?.some((p, i) => i !== idx && p?.id === x.id)
                            )
                            ?.map((x) => ({
                              label: `${x.nome} - ${x?.numero_colori?.[0]?.personalizzazioni_objects?.[0].dimensione_larghezza} x ${x?.numero_colori?.[0]?.personalizzazioni_objects?.[0].dimensione_altezza} cm`,
                              value: x.id,
                            })) || []
                        }
                        value={posizioni?.[idx]?.id}
                        id={`select_pozione_${idx}`}
                        onChange={(opt) => {
                          handleChangePosizione(idx, 'posizione', opt.target.value)
                          resetConfirm()
                        }}
                      />

                      {posizioniDuplicate && (
                        <div className={'configurazione-prodotto__posizioni__select__error'}>
                          {t('Seleziona posizioni diverse per ogni configurazione.')}
                        </div>
                      )}
                    </FormField>
                  </div>
                  {selectedTecnica?.posizioni?.length > 1 && (
                    <div
                      className="configurazione-prodotto__posizioni__description"
                      dangerouslySetInnerHTML={{
                        __html: `<p><strong>* ${t('Attenzione')}:</strong> ${t(
                          'il numero massimo di posizioni di stampa selezionabili è 2.'
                        )}<br>${t(
                          '<strong>* Per personalizzazioni diverse</strong> da quelle mostrate contattare il servizio clienti.'
                        )}</p>`,
                      }}
                    />
                  )}
                </div>
                <div className="configurazione-prodotto__posizioni__content">
                  <div className="configurazione-prodotto__posizioni__colore">
                    <span className="configurazione-prodotto__posizioni__select__label">
                      {t('Scegli il tuo colore di stampa')}:
                    </span>
                    {filterColoriByLeadTime(pos.numero_colori, pos, idx).map((n, i) => (
                      <FormRadio
                        key={n.codice}
                        checked={pos.colori.codice === n.codice}
                        label={`${n.nome}${
                          n.full_color
                            ? ''
                            : n.numero_colori > 1
                            ? ` ${t('colori')}`
                            : ` ${t('colore')}`
                        } - ${priceNotation(getPrezzoColore(selectedTecnica, pos, n), 3)} € cad.`}
                        className={'configurazione-prodotto__posizioni__radio'}
                        size={'sm'}
                        color={'blue'}
                        onClick={() => {
                          handleChangePosizione(idx, 'colori', n)
                          resetConfirm()
                        }}
                      />
                    ))}
                    {posizioni.length === 2 && (
                      <div className="configurazione-prodotto__posizioni__actions configurazione-prodotto__posizioni__actions--rimuovi">
                        <Button
                          size="medium"
                          label={t('Rimuovi posizione')}
                          variant="secondary"
                          colorVariant="orange"
                          onClick={() => {
                            resetConfirm()
                            handleRimuoviPosizione(idx)
                            idx > 0 && handleScrollRef(document.getElementById('pos_' + 0))
                          }}
                          className={
                            'configurazione-prodotto__posizioni__buttons configurazione-prodotto__posizioni__buttons__rimuovi'
                          }
                          // disabled={isAggiornaPreventivoEnabled}
                        />
                      </div>
                    )}
                  </div>
                  <div className="configurazione-prodotto__posizioni__dimensione">
                    <div>
                      <span className="configurazione-prodotto__posizioni__select__label">
                        {t('Dimensione di stampa')}:
                      </span>
                      <div className="configurazione-prodotto__posizioni__dimensione__value">
                        <div className="configurazione-prodotto__posizioni__dimensione__item ">
                          <Larghezza />
                          {`${
                            pos.numero_colori?.find((n) => pos.colori.codice === n.codice)
                              ?.personalizzazioni_objects?.[0]?.dimensione_larghezza
                          } cm`}
                        </div>
                        <div className="configurazione-prodotto__posizioni__dimensione__item">
                          <Altezza />
                          {`${
                            pos.numero_colori?.find((n) => pos.colori.codice === n.codice)
                              ?.personalizzazioni_objects?.[0]?.dimensione_altezza
                          } cm`}
                        </div>
                      </div>
                    </div>
                    {consigliPerPosizione[posizioni.indexOf(pos)] && (
                      <TecnicaConsigliata
                        consiglio={consigliPerPosizione[posizioni.indexOf(pos)]}
                        onSelect={handleApplicaConsiglio}
                        disabled={
                          isLoading || isUploading || !!configurazioneConsigliata || !formik.isValid
                        }
                      />
                    )}
                  </div>
                  <div className="configurazione-prodotto__posizioni__imageColumn">
                    {getAreaStampa(pos.numero_colori?.[0]?.personalizzazioni_objects?.[0])?.immagine
                      ?.url && (
                      <>
                        <NewModal
                          className="datatable-prodotto__modal"
                          visible={zoomModalIndex === idx}
                          onClose={() => setZoomModalIndex(null)}
                        >
                          <div className="main__image__wrapper">
                            <div className="main__image">
                              <MyImage
                                className=""
                                src={
                                  getAreaStampa(
                                    pos.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                                  ).immagine.url
                                }
                                alt={t('Immagine articolo con area di stampa')}
                                width={800}
                                height={800}
                                loading="eager"
                                onClick={() => setZoomModalIndex(null)}
                              />
                            </div>
                          </div>
                        </NewModal>
                        <div className="configurazione-prodotto__posizioni__imageBox">
                          <button
                            className={'configurazione-prodotto__posizioni__imageBox__zoom'}
                            onClick={() => setZoomModalIndex(idx)}
                          >
                            <Zoom />
                          </button>
                          <div className="configurazione-prodotto__posizioni__image">
                            <MyImage
                              className=""
                              src={
                                getAreaStampa(
                                  pos.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                                ).immagine.url
                              }
                              alt={t('Immagine articolo con area di stampa')}
                              width={400}
                              height={400}
                              loading="eager"
                              onClick={() => setZoomModalIndex(idx)}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}

      {selectedTecnica &&
        posizioni.length === 1 &&
        getLeadTimePersonalizzazione(selectedTecnica, posizioni[0])?.fornitori?.length > 0 &&
        filterPosizioniByLeadTime(selectedTecnica.posizioni)?.length > 1 && (
          <div className="configurazione-prodotto__posizioni__actions">
            <Button
              size="medium"
              label={t("Aggiungi un'altra posizione di stampa")}
              variant="secondary"
              onClick={() => {
                resetConfirm()
                handleAggiungiPosizione()
              }}
              className={'configurazione-prodotto__posizioni__buttons'}
              // disabled={isAggiornaPreventivoEnabled}
            />
          </div>
        )}

      {/* Servizi aggiuntivi */}
      {selectedTecnica && (
        <div className="configurazione-prodotto__item">
          <h2 className="configurazione-prodotto__title">{t('Seleziona i servizi aggiuntivi')}</h2>

          <p className="configurazione-prodotto__description">
            {t('Seleziona il confezionamento disponibile per il tuo prodotto')}
          </p>
          {confezionamentoRichiestoOption === 'D' ? null : confezionamentoRichiestoOption ===
            'N' ? null : (
            <div>
              {!!leadTimeSelected && !leadTimeSelected.confezionamento && (
                <Alert
                  full
                  noClick={true}
                  // variant={'info'}
                  placeholder={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t(
                          'La quantità massima per il confezionamento da web è: <strong>{0} pz</strong>',
                          [leadTimeSelected?.max_quantita_confezionamento || 9999]
                        ),
                      }}
                    />
                  }
                  link={null}
                  className="configurazione-prodotto__alert-confezionamento"
                />
              )}
              {leadTimeSelected?.alert_quantita_confezionamento &&
                quantitaTotale >= leadTimeSelected.alert_quantita_confezionamento && (
                  <Alert
                    full
                    noClick={true}
                    variant={'warning'}
                    icon={<></>}
                    placeholder={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t(
                            "Per questo quantitativo le date di spedizione verranno verificate dall'ufficio commerciale alla conferma dell'ordine.<br />Puoi anche richiedere un preventivo personalizzato su misura all'ufficio commerciale."
                          ),
                        }}
                      />
                    }
                    link={null}
                    className="configurazione-prodotto__alert-confezionamento"
                  />
                )}
              <FormCheckbox
                label={
                  t('Richiedi Confezionamento per') +
                  ' ' +
                  `${priceNotation(prezzoConfezionamento, 3)} €`
                }
                type="checkbox"
                checked={confezionamentoRichiesto}
                onChange={(e) => {
                  setConfezionamentoRichiesto(e.target.checked ? true : false)
                  resetConfirm()
                }}
                color={'blue'}
                className={'configurazione-prodotto__posizioni__checkbox'}
                disabled={!leadTimeSelected?.confezionamento || !isLeadTimeValid} // è abilitato solo se il fornitore selezionato può farlo
              />
            </div>
          )}
          {confezionamentoRichiestoOption === 'D' && (
            <div>
              <FormCheckbox
                label={`${confezionamentoLabel} (${t('senza costi aggiuntivi')})`}
                type="checkbox"
                checked={true}
                color={'blue'}
                className={'configurazione-prodotto__posizioni__checkbox'}
                disabled={true}
              />
            </div>
          )}
          {confezionamentoRichiestoOption === 'N' && (
            <div>
              <FormCheckbox
                label={`${confezionamentoLabel} (${t('senza costi aggiuntivi')})`}
                type="checkbox"
                checked={true}
                color={'blue'}
                className={'configurazione-prodotto__posizioni__checkbox'}
                disabled={true}
              />
            </div>
          )}

          <p className="configurazione-prodotto__description configurazione-prodotto__description__lavorazione">
            {t(
              'Inserisci il nome lavorazione, se non specificato, verrà creato un identificativo automatico'
            )}
          </p>
          <FormField
            id={`nome_lavorazione`}
            status={
              formik.touched.nomeLavorazione && formik.errors.nomeLavorazione ? 'error' : undefined
            }
            errorMessage={formik.errors.nomeLavorazione ? formik.errors.nomeLavorazione : undefined}
            infoMessage={
              nomeLavorazioneAssegnato &&
              nomeLavorazioneAssegnato !== formik.values.nomeLavorazione ? (
                <>
                  <span className="configurazione-prodotto__tooltip">
                    <Tooltip
                      label={t(
                        'Il nome lavorazione inserito è già stato usato in passato. Aggiungeremo un numero specifico per renderlo univoco'
                      )}
                    >
                      <Info />
                    </Tooltip>
                  </span>
                  {nomeLavorazioneAssegnato}
                </>
              ) : null
            }
          >
            <FormInput
              name="nomeLavorazione"
              value={formik.values.nomeLavorazione}
              placeholder={t('Nome lavorazione (opzionale)')}
              type="text"
              onChange={(e) => {
                resetConfirm()
                setNomeLavorazioneAssegnato(null)
                formik.handleChange(e)
              }}
              disabled={!isLeadTimeValid}
              onBlur={formik.handleBlur}
            />
          </FormField>
        </div>
      )}

      {/* Conferma */}
      {selectedTecnica && posizioni.length > 0 && isLeadTimeValid && (
        <div className="configurazione-prodotto__item" id="configurazione-prodotto__buttons">
          <h2 className="configurazione-prodotto__title">
            {t('Aggiorna il preventivatore e inviaci la grafica')}
          </h2>
          <p className="configurazione-prodotto__description">
            {t('Aggiorna il prezzo e poi seleziona come preferisci inviarci il file per la stampa')}
          </p>
          <div className="configurazione-prodotto__buttons">
            {isAggiornaPreventivoEnabled && (
              <>
                <Button
                  size="medium"
                  label={
                    isEdit
                      ? t('Carica il logo e aggiorna il carrello')
                      : t('Carica il logo e aggiungi al carrello')
                  }
                  variant={'secondary'}
                  onClick={() => setModalLogoOpen(true)}
                  disabled={!isValid || isUploading || isLoading}
                  className={'configurazione-prodotto__buttons__submit'}
                  icon={<Clipboard />}
                  icon_pos={'left'}
                />
                {hasEditorPerm(utente, service_gift) ? (
                  <Button
                    size="medium"
                    label={t('Crea la tua bozza con il nostro editor')}
                    href={editorHref}
                    next={true}
                    variant="primary-gradient"
                    icon={<Customize />}
                    icon_pos="left"
                    disabled={!isValid || isUploading || isLoading || !personalizzazioneCarrello}
                    className={'configurazione-prodotto__buttons__editor'}
                  />
                ) : (
                  <Tooltip
                    label={'Coming soon'}
                    containerClassName={'configurazione-prodotto__buttons__tooltip'}
                  >
                    <Button
                      size="medium"
                      label={t('Crea la tua bozza con il nostro editor')}
                      variant="primary-gradient"
                      icon={<Customize />}
                      icon_pos="left"
                      disabled={true}
                      // disabled={!isValid || isUploading}
                      className={'configurazione-prodotto__buttons__editor'}
                    />
                  </Tooltip>
                )}
              </>
            )}
            {!isAggiornaPreventivoEnabled && (
              <Button
                size="medium"
                label={t('Aggiorna il preventivatore e carica il tuo logo')}
                variant="primary-gradient"
                onClick={() => {
                  aggiornaPreventivo()
                }}
                disabled={!isValid || isUploading || isLoading || !!configurazioneConsigliata}
                className={'configurazione-prodotto__buttons__confirm'}
              />
            )}
          </div>
        </div>
      )}

      {(!isEdit || (isEdit && !isAggiornaPreventivoEnabled)) && (
        <Button
          label={t('Annulla personalizzazione')}
          onClick={() => setShowAnnullaConfigurazioneModal(true)}
          variant="ghost"
          colorVariant="orange"
        />
      )}
      <NewModal
        visible={modalLogoOpen}
        closeOnOverlayClick={false}
        onClose={() => setModalLogoOpen(false)}
        title={t('Caricamento loghi')}
        className={'configurazione-prodotto__modal'}
      >
        <ConfigurazioneProdottoConferma
          articoliPreventivo={articoliPreventivo}
          onConfirm={(filesSelected) => {
            setModalLogoOpen(false)
            MakePayloadWithFiles(filesSelected, AddToCartMain)
            trackFinalStep(first_articolo, prodotto, selectedTecnica)
            trackingAddCart(ordine, 'standard_order')
          }}
          onCreaOfferta={(filesSelected) => {
            setModalLogoOpen(false)
            MakePayloadWithFiles(filesSelected, () => {})
            trackFinalStep(first_articolo, prodotto, selectedTecnica)
            trackingCreaOfferta(ordine)
            router?.push(`/crea-offerta?cart=${ordine?.id}`)
          }}
          onSaveLater={
            !!SaveLater
              ? (filesSelected) => {
                  setModalLogoOpen(false)
                  MakePayloadWithFiles(filesSelected, SaveLater)
                  trackFinalStep(first_articolo, prodotto, selectedTecnica)
                  trackingSalvaPerDopo(ordine)
                }
              : undefined
          }
          handleChange={handleChangePosizione}
          stessoLogo={posizioni.length === 1}
          posizioni={posizioni}
          variant={variant}
        />
      </NewModal>
      <NewModal
        alert={true}
        visible={showAnnullaConfigurazioneModal}
        onClose={() => setShowAnnullaConfigurazioneModal(false)}
        title={t('Sei sicuro di voler annullare la personalizzazione?')}
        text={t("Cliccando su 'Conferma e procedi' perderai la configurazione creata.")}
        actions={[
          <Button
            label={t('Annulla e torna indietro')}
            variant="primary"
            size="medium"
            onClick={() => {
              trackingGAEventProdotto(
                'customization_delete',
                'annulla',
                undefined,
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
              setShowAnnullaConfigurazioneModal(false)
            }}
          />,
          <Button
            label={t('Conferma e procedi')}
            variant="secondary"
            size="medium"
            onClick={() => {
              setShowAnnullaConfigurazioneModal(false)
              variant === 'personalizzazione'
                ? router.push('/cart/')
                : setShowPersonalizzaForm(false)
              trackingGAEventProdotto(
                'customization_delete',
                'conferma_e_procedi',
                undefined,
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
            }}
          />,
        ]}
      />
      {quantita?.length > 0 && (
        <NewModal
          visible={showPrenotazioneModal}
          alert={true}
          title={t('La quantità inserita non è disponibile, desideri prenotarla?')}
          text={
            <>
              <p>
                {t(
                  'La quantita inserita non è disponibile subito, ma è possibile prenotarla su più arrivi.'
                )}
                <br />
                {t(
                  "L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste."
                )}
              </p>
              <p>{t('Se vuoi ricevere subito gli articoli, inserisci una quantità disponibile')}</p>
            </>
          }
          className={'prenota-modal'}
          onClose={() => setShowPrenotazioneModal(false)}
          actions={[
            <Button
              label={t('Modifica quantità')}
              variant="secondary"
              size="medium"
              onClick={() => setShowPrenotazioneModal(false)}
            />,
            <Button
              label={t('Conferma prenotazione')}
              variant="primary"
              size="medium"
              onClick={() => {
                aggiornaPreventivo(true)
              }}
            />,
          ]}
        >
          <ModalBlocks.ProssimiArrivi
            articoli={quantita?.filter((a) => a.prenotazione && a.quantita > 0)}
          />
        </NewModal>
      )}
      <NoFornitoreModal
        isVisible={showNoFornitoreModal}
        onClose={() => {
          reset()
          setShowNoFornitoreModal(false)
        }}
        tecnica={selectedTecnica}
        maxQuantita={leadTimeSelected?.max_quantita_ordinabile}
      />
    </div>
  )
}

export default ConfigurazioneProdotto
